// Entry point for the build script in your package.json

// Import and start Stimulus first
import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();

// Import Turbo
import "@hotwired/turbo-rails";

// Import controllers
import "./controllers";

// Load other dependencies
import "flowbite";
import "flowbite/dist/flowbite.turbo.js";

// Initialize analytics
// import posthog from "posthog-js";

// posthog.init("phc_E8carc5nNfGspX5nLjf1N1LFUKRIw6pgRwsFDsrqifY", {
//   api_host: "https://webhook.site/d4198d65-a623-4c30-bb75-b770d0291e0e",
//   person_profiles: "identified_only" // or 'always' to create profiles for anonymous users as well
// });

// Initialize dropdowns after DOM content is loaded
document.addEventListener("DOMContentLoaded", function () {
  initializeDropdowns();
});

// Also initialize on turbo navigations
document.addEventListener("turbo:render", function () {
  initializeDropdowns();
});

document.addEventListener("turbo:load", function () {
  initializeDropdowns();
});

// Initialize dropdowns function
function initializeDropdowns() {
  const dropdowns = document.querySelectorAll(".dropdown");

  dropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector("button");
    const menu = dropdown.querySelector(".dropdown-menu");

    if (!button || !menu) return;

    // Remove existing event listeners to prevent duplicates
    button.replaceWith(button.cloneNode(true));
    const newButton = dropdown.querySelector("button");

    newButton.addEventListener("click", function (e) {
      e.stopPropagation();
      menu.classList.toggle("hidden");
    });
  });

  // Handle closing dropdowns when clicking outside
  document.addEventListener("click", function (e) {
    dropdowns.forEach((dropdown) => {
      const menu = dropdown.querySelector(".dropdown-menu");
      if (menu && !dropdown.contains(e.target)) {
        menu.classList.add("hidden");
      }
    });
  });
}
